import { Model } from ".";

export default class Carrier extends Model {
	get singularNoun() {
		return "carrier";
	}

	resource() {
		return "carriers";
	}
}
